module.exports = __webpack_public_path__ + "static/media/download.b9f9697a.svg";